export const apiUrl = "https://the-best-dish.herokuapp.com";
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
